"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _CharacteristicsDetails = _interopRequireDefault(require("./CharacteristicsDetails"));
var _services = require("../../../../services");
var _CustomIconOrImage = _interopRequireDefault(require("../../../shared/CustomIconOrImage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CharacteristicsGroup = _ref => {
  let {
    group,
    characteristics
  } = _ref;
  const {
    name,
    icon
  } = group;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerHeader, null, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    name: icon,
    group: "midLight",
    size: 1
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      left: 3
    }
  }, _services.Services.locale.localeString(`AccessoryModal.${name}`))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerBody, null, characteristics.map(characteristic => /*#__PURE__*/_react.default.createElement(_CharacteristicsDetails.default, {
    key: characteristic.name,
    characteristic: characteristic
  }))));
};
var _default = CharacteristicsGroup;
exports.default = _default;